/*
 * search-global-link.js
 *
 * Header magnifier -> Sarah & Sebastian style search overlay.
 *
 * The overlay itself is the search-overlay section (header group,
 * rendered on every page, editable in the theme editor). Clicking
 * any header search icon slides it down over the current page; no
 * navigation happens until the visitor submits a search. Falls back
 * to navigating to /search if the overlay section was removed in
 * the editor.
 *
 * Both header search icons are <summary class="header__icon--search">
 * elements whose default action toggles the theme's old <details>
 * popup; capture-phase preventDefault cancels that before it opens.
 */
(function () {
  'use strict';

  function openOverlay() {
    var overlay = document.getElementById('k-search-overlay');
    if (!overlay) {
      window.location.href = '/search';
      return;
    }
    document.body.classList.add('k-search-open');
    var input = overlay.querySelector('input[type="search"]');
    if (input) {
      setTimeout(function () { input.focus(); }, 420);
    }
  }

  function closeOverlay() {
    document.body.classList.remove('k-search-open');
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('.header__icon--search')) {
      e.preventDefault();
      e.stopPropagation();
      openOverlay();
      return;
    }
    if (t.closest('[data-k-search-close]')) {
      e.preventDefault();
      closeOverlay();
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeOverlay();
  });
})();
